export enum TicketStatusEnum {
  UserAnswer = 0,
  OperatonAnswer = 2,
}
